import { useState } from "react";
import { withRouter } from "react-router-dom";
import { Dialog, TableRow, TableCell, Tooltip } from "@material-ui/core";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import moment from "moment";
import { useSnackbar } from "notistack";
import { dayMonthDateFormat, fieldDMYShort } from "../../../../constants";
import ShowAttachments from "../../../../shared_elements/components/ShowAttachments";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import { permissionCheckFnforCamo, checkApiStatus } from "../../../../utils";
import { globalGetService, globalPutService, globalDeleteService } from "../../../../utils/globalApiServices";
import { acumenCamo } from "../../../../shared_elements/components";

const mergeAttachments = ({ attachments = [], checklist } = {}) => {
	const files = checklist?.files || [];
	const folders = checklist?.folders || [];
	return [...attachments, ...files, ...folders];
};

const getAttachmentCount = (item) => {
	const { attachments, checklist } = item;
	const { files, folders } = checklist || {};
	const total = (attachments?.length || 0) + (files?.length || 0) + (folders?.length || 0);
	return total || '--';
};

const HtList = ({
	item,
	toggleModalFn,
	toggleDelteModalFn,
	downloadAllApi,
	getResponseBack,
}) => {
	const { enqueueSnackbar } = useSnackbar();
	const [openAttachmentsDialog, setOpenAttachmentsDialog] = useState(false);
	const [allAttachments, setAllAttachments] = useState(null);
	const [lessMore, setLessMore] = useState({});

	const timezone = moment().format();
	const timestamp = Math.floor(Date.now() / 1000);
	const hturl = `audit/camo/htcomponent/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`;

	const fetchAndShowAttachments = () => {
		globalGetService(`camo/ht/view/${item.id}/`).then((response) => {
			if (checkApiStatus(response)) {
				const data = response.data.data;
				const merged = mergeAttachments(data);
				if (merged.length > 0) {
					setAllAttachments(merged);
					setOpenAttachmentsDialog(true);
				}
			}
		});
	};

	const refreshAttachments = () => {
		globalGetService(`camo/ht/view/${item.id}/`).then((response) => {
			if (checkApiStatus(response)) {
				const data = response.data.data;
				const merged = mergeAttachments(data);
				if (merged.length > 0) {
					setAllAttachments(merged);
					setOpenAttachmentsDialog(true);
				}
				getResponseBack();
			}
		});
	};

	const removeAttachment = (attachmentItem, checklist, fileId, uuid) => {
		if (uuid) {
			const payload = {
				delete: true,
				folder_ids: checklist.filter(i => i.type === 'folder').map(f => f.id).filter(id => id !== fileId).toString(),
				file_ids: checklist.filter(i => i.type === 'file').map(f => f.id).filter(id => id !== fileId).toString(),
			};
			globalPutService(`camo/ht/${attachmentItem?.id}/document-checklists/`, payload).then((response) => {
				if (checkApiStatus(response)) refreshAttachments();
			});
		} else {
			globalDeleteService(`camo/attachment/${fileId}/delete/`).then((response) => {
				if (response.status === 500) {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				} else {
					refreshAttachments();
				}
			});
		}
	};

	const toggleLessMore = (key) => setLessMore(prev => ({ ...prev, [key]: !prev[key] }));

	const lessMoreFn = (name, key) => (
		<>
			{name && name.length > 35 ? (
				<>
					{lessMore[key] ? (
						<>
							{name}
							<span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(key); }}> ..less</span>
						</>
					) : (
						<>
							{name.substring(0, 35)}
							<span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(key); }}> ..more</span>
						</>
					)}
				</>
			) : name || '--'}
		</>
	);

	const attachmentCount = getAttachmentCount(item);

	return (
		<>
			<TableRow
				hover
				tabIndex={-1}
				style={{ cursor: "pointer" }}
				className="engine-module-table"
			>
				<TableCell>
					<div style={{ display: "flex", justifyContent: "center", gap: "4px" }}>
						{permissionCheckFnforCamo({ primaryKey: "ht_component", keyIndex: "U" }) ? (
							<Tooltip title="Edit" arrow placement="top">
								<CreateOutlinedIcon color="primary" className="ht-table__edit-icon" onClick={toggleModalFn} />
							</Tooltip>
						) : null}
						{(permissionCheckFnforCamo({ primaryKey: "ht_component", keyIndex: "D" }) ||
							permissionCheckFnforCamo({ primaryKey: "ht_component", keyIndex: "OD", userId: item.created_by })) ? (
							<Tooltip title="Delete" arrow placement="top">
								<DeleteOutlinedIcon color="secondary" className="ht-table__delete-icon" onClick={toggleDelteModalFn} />
							</Tooltip>
						) : null}
						<RevisionHistory buttonType={true} url={hturl} />
					</div>
				</TableCell>
				<TableCell>{item.ata_chapter || "--"}</TableCell>
				<TableCell>{lessMoreFn(item?.part_description, "part_description")}</TableCell>
				<TableCell>{item.part_number || "--"}</TableCell>
				<TableCell>{item.part_serial_number || "--"}</TableCell>
				<TableCell>{item.part_installation_date ? moment(item.part_installation_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</TableCell>
				<TableCell>{item.aircraft_tsn_installation || "--"}</TableCell>
				<TableCell>{item.aircraft_csn_installation || "--"}</TableCell>
				<TableCell>{item.part_tsn_installation || "--"}</TableCell>
				<TableCell>{item.part_csn_installation || "--"}</TableCell>
				<TableCell>{item.ht_requirement || "--"}</TableCell>
				<TableCell>
					{["D", "FH,D", "FC,D", "FC,FH,D"].includes(item.dimension_type) ? "D" : "--"}
				</TableCell>
				<TableCell>
					{["FH", "FH,D", "FC,FH,D", "FC,FH"].includes(item.dimension_type) ? "FH" : "--"}
				</TableCell>
				<TableCell>
					{["FC", "FC,D", "FC,FH,D", "FC,FH"].includes(item.dimension_type) ? "FC" : "--"}
				</TableCell>
				<TableCell>
					{["D", "FC,D", "FH,D", "FC,FH,D"].includes(item.dimension_type)
						? (item.remaining?.due_at_type === "d" ? item.remaining?.due_at : "--")
						: "--"}
				</TableCell>
				<TableCell>
					{["FH", "FH,D", "FC,FH", "FC,FH,D"].includes(item.dimension_type)
						? item.remaining?.due_at
						: "--"}
				</TableCell>
				<TableCell>
					{["FC", "FC,D", "FC,FH", "FC,FH,D"].includes(item.dimension_type)
						? (item.remaining?.due_at_type === "s" && (item.remaining?.s_type === 'fc' || item.remaining?.s_type === null)
							? item.remaining?.due_at
							: "--")
						: "--"}
				</TableCell>
				<TableCell>
					{["D", "FC,D", "FH,D"].includes(item.dimension_type)
						? (item.remaining?.due_at_type === "d" ? item.remaining?.remaining : "--")
						: "--"}
				</TableCell>
				<TableCell>
					{["FH", "FH,D", "FC,FH", "FC,FH,D"].includes(item.dimension_type)
						? (item.remaining?.due_at_type === "s" && (item.remaining?.s_type === 'fh' || item.remaining?.s_type === null)
							? item.remaining?.remaining
							: "--")
						: "--"}
				</TableCell>
				<TableCell>
					{["FC", "FC,D", "FC,FH", "FC,FH,D"].includes(item.dimension_type)
						? (item.remaining?.due_at_type === "s" && (item.remaining?.s_type === 'fc' || item.remaining?.s_type === null)
							? item.remaining?.remaining
							: "--")
						: "--"}
				</TableCell>
				<TableCell>{lessMoreFn(item?.remark, "remark")}</TableCell>
				<TableCell>
					{attachmentCount !== '--' ? (
						<Tooltip title="View Attachments">
							<span className="center" onClick={fetchAndShowAttachments}>
								<AttachFileIcon className="ht-table__attach-icon" />
								<a href="#" style={{ color: "#0e7fe1" }}>{attachmentCount}</a>
							</span>
						</Tooltip>
					) : "--"}
				</TableCell>
			</TableRow>

			<Dialog
				open={openAttachmentsDialog}
				onClose={() => setOpenAttachmentsDialog(false)}
				id="htDialog"
			>
				<ShowAttachments
					handleClose={() => setOpenAttachmentsDialog(false)}
					handleShowAttachments={allAttachments}
					openAttachment={(file) => window.open(decodeURIComponent(file), "_blank")}
					files={{ title: "HT", extension: "zip", key: "" }}
					downloadAllApi={downloadAllApi}
					moduleId={item.id}
					item={item}
					removeAttachment={removeAttachment}
					editFormId={item.id}
				/>
			</Dialog>
		</>
	);
};

export default withRouter(HtList);
